export default __webpack_public_path__ + "static/media/femimed_gabinet_3.4772ef6c.webp";